import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { tailwindConfig } from '@/style/config';
const colors = {
    blueGray: {
        bg: 'bg-blue-gray-75',
        border: 'border-t-blue-gray-75',
        text: 'text-base',
    },
    gray: {
        bg: 'bg-gray-100',
        border: 'border-t-gray-100',
        text: 'text-base',
    },
    primary: {
        bg: 'bg-navy-100',
        border: 'border-t-navy-100',
        text: 'text-white',
    },
    secondary: {
        bg: 'bg-orange-100',
        border: 'border-t-orange-100',
        text: 'text-white',
    },
    white: {
        bg: 'bg-gray-50',
        border: 'border-t-gray-50',
        text: 'text-base',
    },
};
const { theme } = tailwindConfig;
const getWrapPaddingCss = (d) => `
  ${d === 'up' ? 'padding-top: 15px;' : ''}
  ${d === 'down' ? 'padding-bottom: 15px;' : ''}
  ${d === 'left' ? 'padding-left: 15px;' : ''}
  ${d === 'right' ? 'padding-right: 15px;' : ''}
`;
const getDirectionsCss = (d) => `
  ${d === 'up' ? 'transform: rotate(180deg);' : ''}
  ${d === 'down' ? 'transform: rotate(0deg);' : ''}
  ${d === 'left' ? 'transform: rotate(90deg);' : ''}
  ${d === 'right' ? 'transform: rotate(270deg);' : ''}
`;
const getPositionsCss = (d, p) => `
  ${d === 'up' || d === 'down'
    ? `margin-left: -15px; ${p === 'center' ? 'left: 50%;' : 'left: 24px;'}`
    : ''}
  ${d === 'right' || d === 'left'
    ? `margin-top: -15px; ${p === 'center' ? 'top: 50%;' : 'top: 24px;'}`
    : ''}
`;
const getArrowSize = (d, a) => `
  ${d === 'up' ? `bottom: ${a === 'md' ? '100%' : 'calc(100% - 6px)'};` : ''}
  ${d === 'down' ? `top: ${a === 'md' ? '100%' : 'calc(100% - 6px)'};` : ''}
  ${d === 'left' ? `right: ${a === 'md' ? 'calc(100% + 5px)' : '100%'};` : ''}
  ${d === 'right' ? `left: ${a === 'md' ? 'calc(100% + 5px)' : '100%'};` : ''}
`;
const getMedia = (s, className) => `
  @media (min-width: ${theme.screens[s]}) {
    ${className}
  }
`;
export const Balloon = (props) => {
    const { arrowClassName = '', arrowSize = 'md', children, className = '', color = 'white', direction, innerClassName = '', isArrow = true, isRounded = false, isShadow = false, position = 'center', responsiveDirection, } = props;
    const customWrapStyle = css `
    ${getWrapPaddingCss(direction)}
    ${responsiveDirection
        ? getMedia(responsiveDirection.screen, `
            padding: 0;
            ${getWrapPaddingCss(direction)}
          `)
        : ''}
  `;
    const customArrowStyle = css `
    ${getDirectionsCss(direction)}
    ${getPositionsCss(direction, position)}
    ${getArrowSize(direction, arrowSize)}
    ${responsiveDirection
        ? getMedia(responsiveDirection.screen, ` 
            inset: auto;
            margin: 0; 
            ${getDirectionsCss(responsiveDirection.direction)}
            ${getPositionsCss(responsiveDirection.direction, position)}
            ${getArrowSize(responsiveDirection.direction, arrowSize)}
          `)
        : ''}
  `;
    return (_jsx("div", Object.assign({ className: clsx(className), css: customWrapStyle }, { children: _jsxs("div", Object.assign({ className: clsx('relative', colors[color].bg, colors[color].text, isShadow && 'shadow-md', isRounded && 'rounded-md', innerClassName) }, { children: [children, isArrow && (_jsx("span", { className: clsx('absolute', 'w-0 h-0', 'border-solid', 'border-b-transparent', 'border-y-[15px] border-x-[10px] border-x-transparent', colors[color].border, arrowClassName), css: customArrowStyle }))] })) })));
};
